/**
 * VideoModal - Full-screen modal for playing embedded YouTube videos
 */

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  title?: string;
}

export function VideoModal({ isOpen, onClose, videoId, title = "Video" }: VideoModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
      onClick={onClose}
    >
      {/* Video + Close button container */}
      <div
        className="flex flex-col items-center gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Video container - smaller size for shorts */}
        <div className="relative w-[280px] aspect-[9/16] rounded-2xl overflow-hidden shadow-2xl">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
            title={title}
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        {/* Close button - below video */}
        <button
          onClick={onClose}
          className="flex items-center justify-center w-12 h-12 rounded-full bg-white/20 hover:bg-white/30 active:scale-95 transition-all border border-white/20"
          aria-label="Close video"
        >
          <span className="material-symbols-outlined text-white text-2xl">close</span>
        </button>
      </div>
    </div>
  );
}
